import { useIntl } from 'react-intl';

import { useClientProps } from '../ProfileMenu/providers/ClientPropsProvider';

export function useLocale() {
  const { locale } = useIntl();
  const { config } = useClientProps();
  return config?.locale ?? locale;
}
